<template>
  <div class="industry-solution">
    <div class="sk-mobile-title">
      <div class="title">行业解决方案</div>
    </div>
    <div class="content">
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun01.png" alt="">
        家用电器
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun02.png" alt="">
        农资行业
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun03.png" alt="">
        交通出行
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun04.png" alt="">
        酒水饮料
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun05.png" alt="">
        家居建材
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun06.png" alt="">
        数码3C
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun07.png" alt="">
        餐饮行业
      </div>
      <div class="item">
        <img src="@/assets/Mobile/images/solution/fun08.png" alt="">
        快消行业
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndustrySolution',
  data() {
    return {
    }
  },
  watch: {
    '$route'(to, from) {
      console.log('当前路由：', to)
    }
  }
}
</script>

<style lang="less" scoped>
  .industry-solution {
    height: 318px;
    background: url("~@/assets/Mobile/images/home/industry-bg.png") no-repeat center;
    background-size: 102%;
    .title {
      color: #fff !important;
    }
    .content {
      padding: 16px 0 14px 0;
      display: flex;
      width: 375px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      .item {
        display: flex;
        flex-direction: column;
        margin: 15px;
        font-size: 12px;
        line-height: 32px;
        color: #FFFFFF;
      }
      img {
        width: 62px;
        height: 62px;
      }
    }
  }
</style>
